// extracted by mini-css-extract-plugin
module.exports = {"aplixErrorDialogRoot":"aplixErrorDialogRoot--d60bf"};